export function userInitialsFormatFilter () {
	return function (user) {
		return (user.first_name.charAt(0) + user.last_name.charAt(0)).toUpperCase();
	};
}
